// © Microsoft Corporation. All rights reserved.

/** String resource to be used in the Card Action components */
export const StringResource = {
    dialogStrings: {
        dialogButtonClose: "close dialog",
        dialogTitle: "Share",
        copyButton: "Copy",
        copiedButton: "Link Copied",
        copyButtonAriaLabel: "copy link to clipboard",
        copiedButtonAriaLabel: "link copied to clipboard"
    }
};